import { gql } from '../../../apollo/__generated__';

export const CURRENT_USER = gql(`
  query CurrentUser {
    currentUser {
      id
      firstname
      lastname
      nickname
      email
      isAdmin
      isStaff
      isValidator
      folklore
      studyTown
      studies
      phone
      externalReferentLastname
      externalReferentFirstname
      externalReferentPhone
      birthdate
      food
      allergies
      medication
      images {
        id
        url
        originalName
      }
    }
  }
`);
